import r from "../managers/braze-instance.js";
import HtmlMessage from "./models/html-message.js";
import se from "./in-app-message-manager-factory.js";
import { logger as E, EventTypes as m } from "../../shared-lib/index.js";
import ot from "../triggers/models/trigger-events.js";
import { TriggersProviderFactory as rt } from "../triggers/triggers-provider-factory.js";
export function logInAppMessageHtmlClick(e, t, s) {
  if (!r.rr()) return !1;
  if (!(e instanceof HtmlMessage)) return E.error("inAppMessage argument to logInAppMessageHtmlClick must be an HtmlMessage object."), !1;
  var o = m.$i;
  null != t && (o = m.Fi);
  var i = se.ea().rt(e, o, t, s);
  if (i.W) for (var _r = 0; _r < i.ue.length; _r++) rt.o().ve(ot.Qr, [e.triggerId, t], i.ue[_r]);
  return i.W;
}